import {apolloClient, gql} from '../graphql';
import {keyBy} from 'shared/src/map';
import type {Category, CategoryGroup} from 'shared/src/models';

export const getCategoryGroups = async (): Promise<CategoryGroup[]> => {
	const {data, error} = await apolloClient.query({
		query: gql(/* GraphQL */ `
			query GetCategoryGroups {
				categoryGroups {
					id
					name
					priority
					hidden
					categories {
						id
						name
						priority
						hidden
					}
				}
			}
		`),
		fetchPolicy: 'no-cache',
	});

	if (error) {
		throw error;
	}

	return data.categoryGroups.map((categoryGroup) => ({
		...categoryGroup,
		categories: categoryGroup.categories.map((category) => ({
			...category,
			categoryGroup,
		})),
	}));
};

export const getCategories = async (): Promise<Map<string, Category>> => {
	const {data, error} = await apolloClient.query({
		query: gql(/* GraphQL */ `
			query GetCategories {
				categoryGroups {
					id
					name
					priority
					hidden
					categories {
						id
						name
						priority
						hidden
					}
				}
			}
		`),
		fetchPolicy: 'no-cache',
	});

	if (error) {
		throw error;
	}

	const categories = data.categoryGroups.flatMap((categoryGroup) =>
		categoryGroup.categories.map((category) => ({
			...category,
			categoryGroup,
		})),
	);

	return keyBy(categories, (category) => category.id);
};
